import React, { useState } from 'react';
import { Box } from '@mui/material';
import SettingsScreen from '../remindMeMobileScreens/SettingsScreen';
import SendTextScreen from '../remindMeMobileScreens/SendTextScreen';
import SendVoiceScreen from '../remindMeMobileScreens/SendVoiceScreen';
import SendImageScreen from '../remindMeMobileScreens/SendImageScreen';
import RemindMeSideMenu from './RemindMeSideMenu';
import InnerTopBar from '../../components/layout/InnerTopBar';
import HistoryScreen from './HistoryScreen';

const ReminMeWebMainScreen = () => {
    const [selected, setSelected] = useState('settings');

    const renderContent = () => {
        switch (selected) {
            case 'settings':
                return <SettingsScreen />;
            case 'sendText':
                return <SendTextScreen />;
            case 'sendVoice':
                return <SendVoiceScreen />;
            case 'sendImage':
                return <SendImageScreen />;
            case 'history':
                return <HistoryScreen />;
            default:
                return null;
        }
    };

    return (
        <Box sx={{ display: 'flex', width: '100vw', height: '100vh' }}>
            <RemindMeSideMenu selected={selected} onSelect={setSelected} />
            <Box sx={{ display: 'flex', flex: 1, justifyContent: "center" }}>
                <InnerTopBar title="Note To Self" />
                <Box sx={{ display: 'flex', width: '50%', padding: 2, mb: 7, minWidth: 400 }}>
                    {renderContent()}
                </Box>
            </Box>
        </Box>
    );
};

export default ReminMeWebMainScreen;